import React from "react";
import {
  Link,
  useLocation
} from "react-router-dom";

import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import CopyrightOutlinedIcon from '@material-ui/icons/CopyrightOutlined';


import sytles from './MainMenu.module.css';



export default function MainMenu() {
    const location = useLocation();
    let initColor = "default";
    if(location.pathname.includes('zonic')){
      initColor = "zonic"
    }
    if(location.pathname.includes('avatar')){
      initColor = "avatar"
    }
    const [open, setOpen] = React.useState(false);
    const [color, setColor] = React.useState(initColor);

    const toggleDrawer = (open: boolean) => (
        event: React.KeyboardEvent | React.MouseEvent,
      ) => {
        if (
          event &&
          event.type === 'keydown' &&
          ((event as React.KeyboardEvent).key === 'Tab' ||
            (event as React.KeyboardEvent).key === 'Shift')
        ) {
          return;
        }
        setOpen(open);
      };

  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  const style = {
    color: `var(--${color}-color)`
  }
  return (
      <div>
        <span style={style}>
          <Button color="inherit" onClick={toggleDrawer(true)}>
              <MenuIcon />
          </Button>
        </span>
        <SwipeableDrawer
        anchor={'left'}
        disableBackdropTransition={!iOS}
        disableDiscovery={iOS} 
        open={open}
        onClose={toggleDrawer( false)}
        onOpen={toggleDrawer( true)}
        >
          <div className={sytles.MainMenu}>
            <div>
                <div style={{height: '170px'}}>
                    <img className={sytles.MainMenuHeader} src="/assets/images/ZONIC_Logo.png" alt="Header Img" />
                </div>
                <div>
                  <h2 className={sytles.Headline}>Bitte wählen ...</h2>
                </div>
                <ul className={sytles.ListMenu}>
                    <li style={{color: 'var(--primary-color)'}} className={sytles.SectionBtn}>
                        <Link to="/zonic" onClick={() => {
                          setOpen(false);
                          setColor("zonic");
                        }}>
                          <div>
                            <h1>Zonic</h1>
                          </div>
                        </Link>
                    </li>
                    <li style={{color: 'var(--primary-color)'}} className={sytles.SectionBtn}>
                        <Link to="/avatar" onClick={() => {
                          setOpen(false);
                          setColor("avatar");
                        }}>
                          <div>
                            <h1>Joker's Cap</h1>
                          </div>
                        </Link>
                    </li>
                </ul>
            </div>
            <div  className={sytles.Footer}>
              <Button size="large" color="inherit" onClick={toggleDrawer(false)} variant="outlined">
                <a href="https://www.merkur-spielewelt.de/impressum/" target="_blank" rel="noreferrer" onClick={() => {setOpen(false); setColor("default");}}>
                    <CopyrightOutlinedIcon />
                </a>
                  {/* <Link  to="/impressum" onClick={() => {setOpen(false); setColor("default");}}>
                  </Link> */}
              </Button>
              <Button size="large" color="inherit" onClick={toggleDrawer(false)} variant="outlined">
                <CloseIcon />
              </Button>
            </div>
          </div>
        </SwipeableDrawer>
      </div>
  );
}